/**
 * 토스페이먼츠 키 구분
 * - 결제위젯: 클라이언트 키에 `gck`, 시크릿에 `gsk` → @tosspayments/payment-widget-sdk
 * - 결제창(API 개별): 클라이언트에 `ck`, 시크릿에 `sk` → @tosspayments/tosspayments-sdk
 * @see https://docs.tosspayments.com/reference/using-api/api-keys
 */
export function isTossWidgetClientKey(clientKey) {
  return typeof clientKey === 'string' && clientKey.includes('gck');
}

/** 결제창 SDK(loadTossPayments) 전용 — 위젯 키면 사용 불가 */
export function assertPaymentWindowClientKey(clientKey) {
  if (!clientKey || typeof clientKey !== 'string') {
    throw new Error('클라이언트 키가 비어 있습니다.');
  }
  const trimmed = clientKey.trim();
  if (trimmed.includes('gck')) {
    throw new Error(
      '이 키는 결제위젯 연동용입니다. 아래 결제위젯 영역에서 결제하거나, 결제창만 쓰려면 API 개별 연동 키(ck)를 넣어 주세요.'
    );
  }
  return trimmed;
}
